export function formatDisplayableTime(secs) {
  const currentTime = new Date(secs * 1000).toISOString().substr(11, 8);
  const [hours, minutes, seconds] = currentTime.split(':');
  const nonMilitaryHour = hours % 12 === 0 ? 12 : hours % 12;
  const formattedHour =
    nonMilitaryHour < 10 ? `0${nonMilitaryHour}` : nonMilitaryHour;

  return [formattedHour, minutes, seconds].join(':');
}
